// a custom page is linked from the navigation with this key; its nav item props carry the page
export const CUSTOM_PAGE_NAV_KEY = 'customPage';

export interface CustomPageNavItemProps {
  pageId?: string;
  slug?: string;
  /** set on a page that is not saved yet, replaced by pageId / slug on save */
  customPageKey?: string;
}

export const parseCustomPageNavItemProps = (props?: string | null): CustomPageNavItemProps => {
  try {
    return JSON.parse(props || '{}');
  } catch {
    return {};
  }
};

export const getCustomPageKey = (props?: string | null) => {
  const { pageId, customPageKey } = parseCustomPageNavItemProps(props);
  return pageId ?? customPageKey;
};

/**
 * Identifies a nav item in the mobile nav editor. Every custom page shares the `customPage` key,
 * so a custom page item is told apart by the page it links to.
 */
export const getMobileNavItemId = (key?: string | null, props?: string | null) =>
  key === CUSTOM_PAGE_NAV_KEY
    ? `${CUSTOM_PAGE_NAV_KEY}:${getCustomPageKey(props) ?? ''}`
    : key ?? '';
